"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Form_1 = require("./Form");
var FormStore = /** @class */ (function () {
    function FormStore() {
        this.forms = mobx_1.observable.map();
    }
    FormStore.prototype.registerForm = function (name, submit, options) {
        var form;
        if (!this.hasForm(name)) {
            form = new Form_1.Form(submit, options);
            this.forms.set(name, form);
        }
        else {
            form = this.getForm(name);
            if (form.attached) {
                // attempt to double register form
                throw (new Error("Form with name \"" + name + "\" already exist. Use \"withFormData\" HOC to extend it"));
            }
        }
        // looks ok, we created new form or retrieved form form store as it was disconnected with keepState=true
        form.attached = true;
        return form;
    };
    FormStore.prototype.extendForm = function (name, options) {
        if (this.hasForm(name)) {
            var form = this.getForm(name);
            form.extendConfiguration(options);
            return form;
        }
        else {
            // tslint:disable-next-line:max-line-length
            throw (new Error("Form with name \"" + name + "\" does not exist so can not be extended. Use \"reactiveMobxForm\" HOC to create it firstly"));
        }
    };
    FormStore.prototype.unRegisterForm = function (name) {
        var form = this.getForm(name);
        form.cleanup();
        this.forms.delete(name);
    };
    FormStore.prototype.detachForm = function (name) {
        var form = this.getForm(name);
        form.attached = false;
    };
    FormStore.prototype.hasForm = function (name) {
        return this.forms.has(name);
    };
    FormStore.prototype.getForm = function (name) {
        return this.forms.get(name);
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Map)
    ], FormStore.prototype, "forms", void 0);
    return FormStore;
}());
exports.FormStore = FormStore;
//# sourceMappingURL=Store.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/Store.js
// module id = 123
// module chunks = 0